import { DashboardOutlined, TableChartOutlined } from "@mui/icons-material";
import { Stack, ToggleButtonGroup } from "@mui/material";
import { TooltipToggleButton } from "./TooltipToggleButton";

interface Props {
  isTableView: boolean;
  onViewToggled: (isTableView: boolean) => void;
}

const ViewToggleButtonGroup = (props: Props) => {
  return (
    <Stack direction="row" spacing={1} alignItems="center">
      <ToggleButtonGroup
        value={props.isTableView}
        color="primary"
        size="small"
        exclusive
        onChange={(_, value: boolean) => {
          if (value != null) {
            props.onViewToggled(value);
          }
        }}
      >
        <TooltipToggleButton title="Table View" value={true}>
          <TableChartOutlined fontSize="large" />
        </TooltipToggleButton>

        <TooltipToggleButton title="Board View" value={false}>
          <DashboardOutlined fontSize="large" />
        </TooltipToggleButton>
      </ToggleButtonGroup>
    </Stack>
  );
};

export { ViewToggleButtonGroup };
